import {bymoTemplateMetadataFactoryCreate} from "../../../doppe-sdk";
import {BymoPagePropsSpecialContentSettingMetadata} from "../../../client-server-common";


export namespace BymoTemplatePagePreview {

    export interface TemplateProps {
        showSocialIconsSkeleton: boolean;
        showProfileTitleSkeleton: boolean;
        showProfileBioSkeleton: boolean;
        showProfilePictureSkeleton: boolean;
        mobileContentInlinePaddingCss: string;
        skeletonButtonsCount: number;
        prefixSkeletonActionButtonsCount: number;
    }
}

const initialValues = {
    showSocialIconsSkeleton: true,
    showProfileTitleSkeleton: true,
    showProfileBioSkeleton: true,
    showProfilePictureSkeleton: true,
    mobileContentInlinePaddingCss: '18px',
    skeletonButtonsCount: 0,
    prefixSkeletonActionButtonsCount: 0
} as BymoTemplatePagePreview.TemplateProps;


export const BymoTemplatePagePreviewMetadata = bymoTemplateMetadataFactoryCreate<BymoTemplatePagePreview.TemplateProps>()({
    initialValues: initialValues,
    resolveProps: bymoPagePRops => {
        return {
            ...initialValues,
            ...bymoPagePRops
        }
    },
    templatePropsMetadata: {
        mobileContentInlinePaddingCss: BymoPagePropsSpecialContentSettingMetadata.Ignored,
        skeletonButtonsCount: BymoPagePropsSpecialContentSettingMetadata.Ignored,
        prefixSkeletonActionButtonsCount: BymoPagePropsSpecialContentSettingMetadata.Ignored,
        showSocialIconsSkeleton: BymoPagePropsSpecialContentSettingMetadata.Ignored,
        showProfileTitleSkeleton: BymoPagePropsSpecialContentSettingMetadata.Ignored,
        showProfileBioSkeleton: BymoPagePropsSpecialContentSettingMetadata.Ignored,
        showProfilePictureSkeleton: BymoPagePropsSpecialContentSettingMetadata.Ignored,
    },
    features: [
        'hasActions', 'hasActionButton'
    ]
})